import { render } from "./DateMessagePart.vue?vue&type=template&id=6c229e9c"
import script from "./DateMessagePart.vue?vue&type=script&lang=js"
export * from "./DateMessagePart.vue?vue&type=script&lang=js"
script.render = render

export default script